import React from "react";
import RadioButton from "@admin/components/RadioButton";
import { RedirectType } from "@admin/domain/notifications/models/NotificationModel";

type Props = {
    redirectType: RedirectType;
    onChange: (redirectType: RedirectType) => void;
    redirectTypeState: RedirectType | null;
};

const labels = {
    [RedirectType.ProductCategory]: `Категория товара`,
    [RedirectType.Product]: `Товар`,
    [RedirectType.NewsArticle]: `Новость`,
    [RedirectType.LiveBroadcast]: `Живой эфир`,
    [RedirectType.Url]: `Ссылка`,
};

export default function RedirectTypeRadioButton({ redirectType, onChange, redirectTypeState }: Props) {
    return (
        <RadioButton
            label={labels[redirectType]}
            name="parameters[redirect_type]"
            value={redirectType}
            checked={redirectType === redirectTypeState}
            onChange={() => onChange(redirectType)}
        />
    );
}
